// src/components/RfiList.js

import React, { useState, useEffect, useContext, useRef } from "react";
import { format } from "date-fns";
import api from "../../api/axiosConfig";
import { useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import { IoEyeOutline } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { ImUpload } from "react-icons/im";

export default function RfiList() {
  const { projectId, rfiId, token } = useParams();
  const [companyDetails, setCompanyDetails] = useState({
    name: "",
    companyregno: "",
    contactno: "",
    email: "",
    hourrate: "",
    website: "",
    logo: "",
    address: "",
    about: "",
    social: { facebook: "", twitter: "", linkedin: "" },
  });
  const [orderedQueries, setOrderedQueries] = useState([]);
  const [rfis, setRfis] = useState(null);
  const [files, setFiles] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [loading, setLoading] = useState(true);
  const inputRef = useRef();
  const [disciplines, setDisciplines] = useState([]);
  const [queryId, setQueryId] = useState(null);
  const [queryNumber, setQueryNumber] = useState(null);
  const [successMessage, setSuccessMessage] = useState({
    queryId: null,
    message: "",
  });

  const [responseDial, setResponseDial] = useState(false);
  useEffect(() => {
    setResponseDial(true);
  }, []);
  // Response form state
  const [responseForm, setResponseForm] = useState({
    responded_by: "",
    responded_date: new Date(),
    response: "",
    company_name: "",
    discipline_id: "",
  });
  function buildTimeline(orderedQueries) {
    return orderedQueries.map((q) => {
      const queryItem = {
        type: "query",
        id: q.id,
        qNo: q.qNo,
        name: q.raised_by_name,
        emp_code: q.raised_by_emp_code,
        time: q.created_at,
        query_text: q.query_text,
        status: q.status,
        responses: [],
      };

      if (q.responses && Array.isArray(q.responses)) {
        queryItem.responses = q.responses.map((res) => ({
          type: "response",
          id: q.id,
          qNo: q.qNo,
          name: res.responded_by,
          time: res.responded_date,
          discipline_name: res.discipline_name,
          company_name: res.company_name,
          response: res.response,
          status: q.status,
          discipline: res.discipline_name,
        }));
      }

      return queryItem;
    });
  }

  function buildOrderedQueries(allQueries) {
    const orderedList = [];

    // Helper: recursively build child revisions
    function addRevisionsRecursively(parent, parentNo) {
      const children = allQueries
        .filter((q) => q.parent_query_id === parent.id)
        .sort((a, b) => a.id - b.id);

      children.forEach((child, index) => {
        // Each child gets a revision number based on position
        const childRev = index + 1;
        const qNo = `${parentNo} R${childRev}`;

        orderedList.push({ ...child, qNo });

        // Recursively handle deeper revisions
        addRevisionsRecursively(child, qNo);
      });
    }

    // Start with top-level parents
    const parents = allQueries
      .filter((q) => !q.parent_query_id)
      .sort((a, b) => a.id - b.id);

    parents.forEach((parent, parentIndex) => {
      const parentNo = `Q${parentIndex + 1}`;
      orderedList.push({ ...parent, qNo: `${parentNo} R0` });

      addRevisionsRecursively(parent, parentNo);
    });

    return buildTimeline(orderedList);
  }

  useEffect(() => {
    if (!rfis?.queries) return;
    const ordered = buildOrderedQueries(rfis.queries);
    setOrderedQueries(ordered);
  }, [rfis]);
  const fetchRfis = async () => {
    try {
      const res = await api.get(`/api/rfi/${projectId}/${rfiId}/${token}`);
      setRfis(Array.isArray(res.data) ? res.data[0] : res.data);

      const comapanyRes = await api.get("/api/company-settings");
      const disciplineRes = await api.get("/api/disciplines");

      setDisciplines(disciplineRes.data || []);
      if (comapanyRes.data) {
        setCompanyDetails((prev) => ({
          ...prev,
          ...comapanyRes.data,
          social: {
            facebook: comapanyRes.data?.social?.facebook || "",
            twitter: comapanyRes.data?.social?.twitter || "",
            linkedin: comapanyRes.data?.social?.linkedin || "",
          },
        }));
      }
      setLoading(false);
    } catch (err) {
      console.error("Error fetching RFIs:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRfis();
  }, []);

  const handleFormChange = (key, value) => {
    setResponseForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleResponse = async (e) => {
    e.preventDefault();
    if (!queryId || !rfis) return;
    console.log("triggered");
    const query = rfis.queries.find((q) => q.id === queryId);
    if (!query) return;
    if (
      !responseForm.response.trim() ||
      !responseForm.responded_by ||
      !responseForm.responded_date ||
      !responseForm.company_name ||
      !responseForm.discipline_id
    ) {
      alert("Please enter valid response");
      return;
    }
    const newResponse = {
      response: responseForm.response,
      responded_by: responseForm.responded_by,
      responded_date: responseForm.responded_date,
      discipline_id: responseForm.discipline_id,
      company_name: responseForm.company_name,
    };
    const updatedResponses = [...(query.responses || []), newResponse];

    try {
      // const res = await api.post(`/api/addresponse/${queryId}`, {
      //   responses: updatedResponses,
      // });

      // Update UI
      // setRfis((prev) => ({
      //   ...prev,
      //   queries: prev.queries.map((q) =>
      //     q.id === queryId ? { ...q, responses: res.data.data } : q
      //   ),
      // }));
      setRfis((prev) => ({
        ...prev,
        queries: prev.queries.map((q) =>
          q.id === queryId ? { ...q, responses: updatedResponses } : q
        ),
      }));
      // Success message
      // setSuccessMessage({
      //   queryId,
      //   message: res.data.message,
      // });

      setTimeout(() => {
        setSuccessMessage({ queryId: null, message: "" });
      }, 1200);
      setResponseForm((prev) => ({
        ...prev,
        response: "",
      }));
      // fetchRfis();
      setResponseDial(false);
    } catch (err) {
      console.error("Error adding response:", err);
    }
  };

  const handleUpdateRfiResponses = async () => {
    const fixedForm = {
      ...rfis,
    };
    try {
      setLoading(true);
      const response = await api.put(`/api/rfis/${rfiId}`, { fixedForm });
      const createdId = response.data?.id;
      if (!createdId) {
        console.error("No rfi id returned by backend", response.data);
        // handle accordingly
      } else {
        if (files && files.length > 0) {
          const fd = new FormData();
          for (let f of files) fd.append("files", f);
          console.log("fd", fd);
          await api.post(`/api/rfis/${createdId}/clientattachments`, fd, {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (progressEvent) => {
              const percent = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress(percent);
            },
          });
        }
      }
      setLoading(false);
      fetchRfis();
      setFileList([]);
      setFiles([]);
    } catch (err) {
      console.log("error");
    }
  };

  const handleFiles = (files) => {
    // const newFiles = Array.from(files).map((file) => ({
    //   file,
    //   file_name: `${queryNumber} ${file.name}`,
    //   size: file.size,
    //   file_lastModified: file.lastModified,
    //   preview: URL.createObjectURL(file),
    //   isImage: file.type.startsWith("image"),
    //   isPdf: file.type === "application/pdf",
    // }));
    const newFiles = Array.from(files).map((file) => {
      const renamedFile = new File([file], `${queryNumber} ${file.name}`, {
        type: file.type,
        lastModified: file.lastModified,
      });

      return {
        file: renamedFile,
        file_name: renamedFile.name,
        size: renamedFile.size,
        file_lastModified: renamedFile.lastModified,
        preview: URL.createObjectURL(renamedFile),
        isImage: renamedFile.type.startsWith("image"),
        isPdf: renamedFile.type === "application/pdf",
      };
    });

    // Push directly into the array (not inside arr)
    setFileList((prev) => [...prev, ...newFiles]);

    // Raw files as well
    setFiles((prev) => [...prev, ...newFiles.map((x) => x.file)]);
  };
  const removeFile = (idx) => {
    const updated = fileList.filter((_, i) => i !== idx);
    setFileList(updated);
    setFiles(updated.map((x) => x.file));
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleFiles(e.dataTransfer.files);
  }; // Cleanup object URLs
  if (loading)
    return (
      <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white">
        {/* Spinner */}
        <div className="w-12 h-12 border-4 border-gray-300 rounded-full border-t-blue-500 animate-spin"></div>

        {/* Loading Text */}
        {fileList.length === 0 && (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <span className="loading-animation">LOADING...</span>
          </div>
        )}

        {/* Upload Progress */}
        {fileList.length > 0 && (
          <div className="w-64 mt-6">
            <p className="mb-2 text-sm text-center text-gray-600">
              Uploading: {uploadProgress}%
            </p>

            <div className="w-full h-3 overflow-hidden bg-gray-200 rounded-full">
              <div
                className="h-full transition-all duration-300 bg-green-500"
                style={{ width: `${uploadProgress}%` }}
              ></div>
            </div>
          </div>
        )}
      </div>
    );

  const parseQueryTextWithLinks = (text, documents) => {
    // Matches:  [File Name.ext]
    const regex = / \[([^\]]+)\]/g;

    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = regex.exec(text)) !== null) {
      const fileName = match[1];

      // Add the plain text before the match
      parts.push(text.slice(lastIndex, match.index));

      // Find document by file_name
      const doc = documents.find((d) => d.file_name === fileName);

      if (doc) {
        // Add a clickable link
        parts.push(
          <a
            key={match.index}
            href={doc.share_url}
            target="_blank"
            rel="noopener noreferrer"
            className="mr-1 text-blue-600 no-underline"
          >
            {fileName}
          </a>
        );
      } else {
        // If not found, just show the text as-is
        parts.push(match[0]);
      }

      lastIndex = regex.lastIndex;
    }

    // Add the remaining text after the last match
    parts.push(text.slice(lastIndex));

    return parts;
  };

  const uniqueDocs = Array.from(
    new Map(rfis?.documents?.map((doc) => [doc.file_name, doc])).values()
  );

  if (!rfis)
    return <div className="p-8 text-center text-gray-500">No RFI found.</div>;

  return (
    <div className="flex items-center justify-center w-full py-8">
      <div className="w-[900px] mx-10 bg-white shadow-xl rounded-xl p-6 border">
        {/* HEADER */}
        <HeaderBlock rfis={rfis} companyDetails={companyDetails} />

        {/* SUBJECT */}
        <SubjectBlock rfis={rfis} />

        {/* GRID DETAILS */}
        <GridDetails rfis={rfis} />

        {/* TIMELINE */}
        <Timeline rfis={rfis} />

        {/* DOCUMENTS */}
        <DocumentsBlock rfis={rfis} uniqueDocs={uniqueDocs} />

        {/* QUERIES */}
        <QueriesBlock
          rfis={rfis}
          orderedQueries={orderedQueries}
          setResponseDial={setResponseDial}
          setQueryId={setQueryId}
          setQueryNumber={setQueryNumber}
          successMessage={successMessage}
          parseQueryTextWithLinks={parseQueryTextWithLinks}
        />
        <div className="flex justify-end w-full">
          <button
            onClick={() => handleUpdateRfiResponses()}
            className="h-auto w-auto px-[10px] py-[6px] text-center border-none text-white rounded-[3px] bg-[#6200ee] cursor-pointer font-lato text-[13px]"
          >
            Submit
          </button>
        </div>
      </div>

      {/* RESPONSE FORM DIALOG */}
      {responseDial && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/40">
          <form
            onSubmit={handleResponse}
            className={`p-0 ${
              queryId
                ? "w-[87vw] sm:w-[60vw]"
                : "w-[83vw] sm:w-[40vw] lg:w-[20vw]"
            } space-y-2 flex bg-white shadow-xl rounded-xl animate-fadeIn`}
          >
            <div className="w-full rounded-t-xl rounded-b-xl">
              <div className="font-normal bg-[#f5f5f5] p-2 pl-[1rem] rounded-t-xl h-[30px] items-center top-0 left-0 z-2 flex flex-row justify-between">
                <h3 className="text-[15px] bg-transparent m-0">
                  {queryId ? "Add Response" : "Client details"}
                </h3>
              </div>
              <div className="flex w-full py-4">
                <div
                  className={`${
                    queryId ? "w-[50%] " : "w-[100vw]"
                  } flex flex-col gap-2`}
                >
                  <FormInput
                    label="Responded by"
                    placeholder="Responded by"
                    value={responseForm.responded_by}
                    onChange={(e) =>
                      handleFormChange("responded_by", e.target.value)
                    }
                  />

                  <FormDatePicker
                    label="Responded date"
                    value={responseForm.responded_date}
                    onChange={(date) =>
                      handleFormChange("responded_date", date)
                    }
                  />

                  {queryId && (
                    <FormTextarea
                      label="Response"
                      value={responseForm.response}
                      onChange={(e) =>
                        handleFormChange("response", e.target.value)
                      }
                    />
                  )}

                  <FormInput
                    label="Company name"
                    placeholder="Company name"
                    value={responseForm.company_name}
                    onChange={(e) =>
                      handleFormChange("company_name", e.target.value)
                    }
                  />

                  <div className="flex flex-col mx-[16px]">
                    <label className="font-normal text-black m-[3px] ml-0 text-[15px]">
                      Select discipline
                    </label>
                    <select
                      value={responseForm.discipline_id}
                      onChange={(e) =>
                        handleFormChange("discipline_id", e.target.value)
                      }
                      className="p-[6px] border-[0.5px] border-solid border-[#ddd]  disabled:text-gray-500  rounded-[3px] font-lato text-[14px] cursor-pointer focus:border-[#535353] focus:outline-none"
                    >
                      <option value="" disabled>
                        Select discipline
                      </option>
                      {disciplines.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {queryId && (
                  <div className="w-[50%]">
                    {/* {queryId && ( */}
                    <div className="flex flex-col h-full p-4 pb-0 pl-0 ">
                      <div
                        className={`flex flex-col items-center justify-center h-[18rem] py-3 text-center transition border-2 bg-gray-50 border-gray-400 border-dashed rounded-lg cursor-pointer ${
                          fileList.length === 0 ? "h-[18rem]" : "h-[7rem]"
                        } hover:border-blue-500`}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={handleDrop}
                        onClick={() => inputRef.current.click()}
                      >
                        <p className="flex flex-col items-center justify-center h-full gap-2 text-sm text-gray-600 bg-transparent">
                          <ImUpload className="w-8 h-8 text-gray-500 bg-transparent" />
                          <p className="m-0 bg-transparent">
                            Drag & drop files here
                          </p>
                          <p className="m-0 bg-transparent">-OR-</p>
                          <span className="h-auto w-auto px-[10px] py-[6px] text-center border-none text-white rounded-[3px] bg-[#6200ee] cursor-pointer font-lato text-[13px]">
                            Browse files
                          </span>
                        </p>
                      </div>

                      {/* Hidden Input */}
                      <input
                        type="file"
                        multiple
                        ref={inputRef}
                        className="hidden"
                        onChange={(e) => handleFiles(e.target.files)}
                      />

                      {/* Preview Section */}
                      {fileList.length > 0 && (
                        <div className="border h-[9rem] border-gray-300 p-4 px-2  rounded-lg gap-4 overflow-auto bg-white">
                          <div className="flex flex-col gap-4 sm:flex sm:flex-col md:flex md:flex-col lg:grid lg:grid-cols-2">
                            {fileList
                              .filter((f) =>
                                f.file_name.startsWith(queryNumber + " ")
                              )
                              .map((item, idx) => (
                                <div
                                  key={idx}
                                  className="flex flex-col p-2 border rounded-md shadow-lg bg-gray-50"
                                >
                                  {item.type?.startsWith("image/") ? (
                                    <img
                                      src={item.preview}
                                      alt={item.file.name}
                                      className="object-cover w-full h-32 border rounded-md"
                                    />
                                  ) : item.type === "application/pdf" ? (
                                    <iframe
                                      src={item.preview}
                                      className="w-full h-32 border rounded-md"
                                      title="PDF Preview"
                                    />
                                  ) : (
                                    <div></div>
                                  )}

                                  <div className="flex items-center justify-between w-full bg-transparent">
                                    <div className="flex flex-col w-full bg-transparent">
                                      <p className="w-[10vw] md:w-[20vw] lg:w-[8vw] text-sm font-medium truncate bg-transparent">
                                        {queryId
                                          ? item.file_name
                                          : item.file?.name}
                                      </p>
                                      <p className="m-0 text-xs text-gray-600 bg-transparent">
                                        {(
                                          (item.size || item.file?.size) / 1024
                                        ).toFixed(1)}{" "}
                                        KB
                                      </p>
                                    </div>

                                    <div className="flex items-center gap-4 bg-transparent">
                                      {queryId && item.id && (
                                        <a
                                          href={item.share_url}
                                          target="_blank"
                                          className="text-[#6200ee]"
                                        >
                                          <IoEyeOutline />
                                        </a>
                                      )}

                                      {!item.id && (
                                        <button
                                          className="text-sm text-red-500 bg-transparent border-none cursor-pointer hover:underline"
                                          onClick={() => removeFile(idx)}
                                          type="button"
                                        >
                                          <RiDeleteBin6Line size={20} />
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* )} */}
                  </div>
                )}
              </div>

              <div className="  border-t border-[#616161] pt-0 h-[50px] flex justify-between items-center px-4 rounded-b-xl bg-white  bottom-0  border-b-0 border-solid border-x-0">
                <div className="flex gap-4">
                  {queryId && (
                    <button
                      type="submit"
                      className="h-auto w-auto px-[10px] py-[6px] text-center border-none text-white rounded-[3px] bg-[#6200ee] cursor-pointer font-lato text-[13px]"
                    >
                      Save
                    </button>
                  )}
                  {!queryId && (
                    <button
                      onClick={() => setResponseDial(false)}
                      className="h-auto w-auto px-[10px] py-[6px] text-center border-none text-white rounded-[3px] bg-[#6200ee] cursor-pointer font-lato text-[13px]"
                    >
                      Save
                    </button>
                  )}

                  <button
                    onClick={() => {
                      setResponseDial(false);
                      setResponseForm({
                        responded_by: "",
                        responded_date: new Date(),
                        response: "",
                        company_name: "",
                        discipline_id: "",
                      });
                    }}
                    type="button"
                    className="h-auto w-auto py-[5px] px-[10px] text-center text-[#6200ee] rounded-[3px] font-normal border border-[#6200ee] bg-transparent cursor-pointer font-lato text-[13px]"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

/* ---------- SMALL REUSABLE COMPONENTS ---------- */

function HeaderBlock({ rfis, companyDetails }) {
  return (
    <div className="w-full pb-4 bg-white border-t-0 border-b border-solid border-x-0">
      <div className="flex flex-col gap-6">
        {/* MOBILE FIRST — SHOW RFI DETAILS AT TOP */}
        {/* <div className="text-center md:hidden">
          <h1 className="text-xl font-bold text-gray-900">RFI Details</h1>
          <p className="text-gray-500">RFI Number: {rfis.rfi_number}</p>
        </div> */}

        <div className="flex flex-row  w-[100%]">
          <div className="flex flex-col justify-between gap-3 w-[100%]">
            <div className="flex flex-row justify-between gap-2 ">
              <p className="m-0 text-[18px] font-bold text-gray-900">
                REQUEST FOR INFORMATION (RFI) FORM
              </p>
              <img
                src={companyDetails.logo}
                className="object-contain w-[10rem] h-[3rem]"
                alt="logo"
              />
            </div>
            <div className="flex flex-col items-start gap-2">
              <div className="flex flex-row items-center">
                <div className="w-[8rem]">
                  <p className="m-0 text-sm font-semibold text-gray-800">
                    Project :
                  </p>
                </div>
                <div className="text-[15px]">
                  {rfis.job_number} – {rfis.job_name}
                </div>
              </div>
              <div className="flex flex-row items-center">
                <div className="w-[8rem]">
                  <p className="m-0 text-sm font-semibold text-gray-700">
                    Phase :
                  </p>
                </div>
                <div className="text-[15px]">
                  {rfis.phase_number} – {rfis.phase_title}
                </div>
              </div>

              <div className="flex flex-row items-center">
                <div className="w-[8rem]">
                  <p className="m-0 text-sm font-semibold text-gray-700">
                    Reference No:{" "}
                  </p>
                </div>
                <div className="text-[15px]">{rfis.rfi_number}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ----- Subject Block ----- */

function SubjectBlock({ rfis }) {
  return (
    <div className="flex flex-col gap-[5px] mt-[16px] pb-4 border-t-0 border-b border-solid border-x-0">
      <div>
        <h2 className="m-0 text-[17px] font-semibold text-gray-900">Subject</h2>
        <p className=" font-medium text-gray-900 text-[15px]">{rfis.subject}</p>
      </div>

      {rfis.description && (
        <div>
          <h2 className="m-0 text-[17px] font-semibold text-gray-900">
            Remarks
          </h2>
          <p className="text-[15px] text-gray-900">{rfis.description}</p>
        </div>
      )}
    </div>
  );
}

/* ----- Grid Details ----- */

function GridDetails({ rfis }) {
  return (
    <div className="flex flex-col gap-2 mt-[16px] sm:grid sm:grid-cols-2 sm:gap-6">
      {/* <div className="space-y-3"> */}
      <Detail label="Phase" value={rfis.phase_title} />

      <Detail
        label="Prepared By"
        value={rfis.requested_by?.map((u) => u.sortcode).join(", ")}
      />

      <Detail
        label="Category"
        value={
          rfis.category_id
            ?.map((c) =>
              c.value === 3 ? rfis.other_category || "Other" : c.label
            )
            .join(", ") || "-"
        }
      />
      {/* </div> */}

      {/* <div className="space-y-3"> */}
      <Detail
        label="Reviewed By"
        value={rfis.reviewed_by?.map((u) => u.sortcode).join(", ")}
      />

      <Detail
        label="Discipline"
        value={
          rfis.discipline_id
            ?.map((d) =>
              d.value === 8 ? rfis.other_discipline || "Others" : d.label
            )
            .join(", ") || "-"
        }
      />

      <Detail
        label="Approved By"
        value={rfis.approved_by?.map((u) => u.sortcode).join(", ")}
      />
    </div>
    // </div>
  );
}

/* ----- Timeline ----- */

function Timeline({ rfis }) {
  return (
    <div className="mt-[8px] sm:mt-[16px] pb-4 border-t-0 border-b border-solid border-x-0">
      {/* <h2 className="m-0 text-lg font-semibold text-gray-700">Timeline</h2> */}
      <div className="flex flex-col gap-2 sm:grid sm:grid-cols-2 sm:gap-6">
        <Detail
          label="Submitted On"
          value={format(rfis.requested_date, "dd-MM-yyyy")}
        />
        <Detail
          label="Due Date"
          value={rfis.due_date ? format(rfis.due_date, "dd-MM-yyyy") : "—"}
        />
      </div>
    </div>
  );
}

/* ----- Documents ----- */

function DocumentsBlock({ rfis, uniqueDocs }) {
  return (
    <div className="mt-[16px] min-h-0 max-h-[30rem] p-2 overflow-auto">
      <h2 className="m-0 mb-2 text-[17px] font-semibold text-gray-900">
        Attached Documents
      </h2>

      {rfis.documents?.length === 0 ? (
        <p className="text-gray-500">No documents uploaded.</p>
      ) : (
        <div className="space-y-3">
          {uniqueDocs.map((doc) => (
            <div
              key={doc.id}
              className="flex items-center justify-between p-3 bg-transparent bg-gray-100 rounded-lg shadow"
            >
              <div>
                <p className="font-medium text-[15px]">{doc.file_name}</p>
                <p className="text-[12px] text-gray-500">
                  {format(doc.uploaded_at, "dd-MM-yyyy")}
                </p>
              </div>

              <div className="flex gap-4">
                <a
                  href={doc.share_url}
                  target="_blank"
                  className="text-blue-600 "
                >
                  <IoEyeOutline className="flex items-center justify-center cursor-pointer px-2 py-2 text-[#6200ee] bg-transparent rounded-full transition-colors duration-300 ease-out hover:bg-[#6200ee]/10 hover:text-[#4500b5]" />
                </a>
                {/* <a
                  href={doc.share_url}
                  target="_blank"
                  download
                  className="text-green-600 hover:underline"
                >
                  Download
                </a> */}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ----- Queries Block ----- */

function QueriesBlock({
  rfis,
  orderedQueries,
  setResponseDial,
  setQueryId,
  setQueryNumber,
  successMessage,
  parseQueryTextWithLinks,
}) {
  return (
    <div className="mt-[16px]">
      <h3 className="m-0 text-[15px] font-semibold text-gray-900">Queries</h3>

      {orderedQueries?.length === 0 ? (
        <p className="text-gray-500">No queries raised.</p>
      ) : (
        <div className="">
          {orderedQueries.map((item, idx) => (
            <div key={idx} className="p-3 px-0 pb-0 ml-4 border-l-2">
              <div className="flex justify-between m-0">
                <div className="flex items-center gap-3">
                  {item.qNo && (
                    <p className="m-0 font-semibold">
                      {item.qNo.split(" ")[0]}{" "}
                      <span className="text-xs font-normal text-black">
                        R{item.qNo.split(" ")[1].replace("R", "")}
                      </span>
                    </p>
                  )}
                  <p className="m-0 text-xs text-gray-500">
                    {format(item.time, "dd-MM-yyyy")}
                  </p>
                  <p
                    className={`px-2 py-1 text-xs m-0 rounded-full ${
                      item.status === "Closed"
                        ? "bg-red-100 text-red-700"
                        : "bg-green-100 text-green-700"
                    }`}
                  >
                    {item.status}
                  </p>
                </div>
                {item.status === "Open" && (
                  <button
                    onClick={() => {
                      setResponseDial(true);
                      setQueryNumber(item.qNo);
                      setQueryId(item.id);
                    }}
                    className="h-auto px-[10px] py-[6px] text-center border-none text-white rounded-[3px] mb-0  font-lato text-[13px] bg-[#6200ee] cursor-pointer"
                  >
                    Add Response
                  </button>
                )}
              </div>

              <p className="mt-1 text-[15px]">
                {parseQueryTextWithLinks(item.query_text, rfis.documents)}
              </p>
              {item.responses.length > 0 && (
                <h3 className="m-0 text-[15px] my-5 font-semibold text-gray-900">
                  Response{item.responses.length > 1 ? "s" : ""}
                </h3>
              )}
              {/* --- RESPONSES UNDER THIS QUERY --- */}
              {item.responses.map((res, rIdx) => (
                <div key={rIdx} className="p-2 px-0 mt-2 ml-6 border-l">
                  <div className="flex items-center justify-start gap-3">
                    <p className="m-0 font-semibold">{res.name}</p>
                    <p className="m-0 text-xs text-gray-500">
                      {format(res.time, "dd-MM-yyyy")}
                    </p>
                    <p className="m-0 text-xs text-gray-500">
                      {res.discipline_name}
                    </p>{" "}
                    <p className="m-0 text-xs text-gray-500 ">
                      {res.company_name}
                    </p>
                    {/* <p
                      className={`px-2 py-1 text-xs rounded-full ${
                        res.status === "Closed"
                          ? "bg-red-100 text-red-700"
                          : "bg-green-100 text-green-700"
                      }`}
                    >
                      {res.status}
                    </p> */}
                  </div>
                  <p className="m-0 mt-1 text-black text-[15px]">
                    {" "}
                    {res.response}
                  </p>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Detail({ label, value }) {
  return (
    <div className="flex flex-row items-center">
      <div className="w-[128px]">
        <p className="m-0 text-sm font-semibold text-gray-800">{label}:</p>
      </div>
      <div className="w-[128px]">
        <p className="text-[15px] text-gray-900">{value || "—"}</p>
      </div>
    </div>
  );
}

/* ----- Form Components ----- */

function FormInput({
  label,
  value,
  onChange,
  type = "text",
  placeholder = "",
  required = false,
}) {
  return (
    <div className="mx-[16px] flex flex-col">
      <label className="font-normal text-black m-[3px] ml-0 text-[15px]">
        {label} {required && <span className="text-red-500">*</span>}
      </label>

      <input
        type={type}
        value={value}
        placeholder={placeholder}
        required={required}
        onChange={onChange}
        className="p-[6px] border-[0.5px] border-solid border-[#ddd] rounded-[3px] font-lato text-[13px] cursor-pointer focus:border-[#535353] focus:outline-none "
      />
    </div>
  );
}

function FormTextarea({
  label,
  value,
  onChange,
  rows = 3,
  placeholder = "",
  required = false,
}) {
  return (
    <div className="mx-[16px] flex flex-col">
      <label className="font-normal text-black m-[3px] ml-0 text-[15px]">
        {label} {required && <span className="text-red-500">*</span>}
      </label>

      <textarea
        rows={rows}
        value={value}
        placeholder={placeholder}
        required={required}
        onChange={onChange}
        className="auto-resize pl-[5px] border border-[#ddd] border-[0.5px] no-scrollbar rounded-[3px] font-lato text-[13px] w-auto  min-h-0 h-auto max-h-[10vh] focus:border-[#535353] focus:outline-none disabled:bg-white disabled:text-gray-500 disabled:cursor-not-allowed disabled:border-white"
      />
    </div>
  );
}

function FormDatePicker({ label, value, onChange, required = false }) {
  return (
    <div className="mx-[16px] flex flex-col">
      <label className="font-normal text-black m-[3px] ml-0 text-[15px]">
        {label} {required && <span className="text-red-500">*</span>}
      </label>

      <DatePicker
        selected={value}
        onChange={onChange}
        dateFormat="dd-MM-yyyy"
        required={required}
        popperPlacement="top"
        disabled
        className="pl-[5px] border border-[0.5px] cursor-pointer border-[#ddd] disabled:text-gray-400 border-solid h-[26px] w-[97%] rounded-[3px]  text-[14px] focus:border-[#535353] focus:outline-none"
      />
    </div>
  );
}
